export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_reviewStatus') || '审批结果',
    field: 'v_reviewStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
  },
  {
    title: that.$l('table_label_reviewByName') || '评审人姓名',
    field: 'reviewByName',
    headerAlign: 'center',
    align: 'center',
    width: 140,
  },
  {
    title: that.$l('table_label_reviewTime') || '评审时间',
    field: 'reviewTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
  },
  {
    title: that.$l('table_label_reviewDesc') || '评审意见',
    field: 'reviewDesc',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
  },
]
